import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=f8d20204&scoped=true"
import script from "./EmptyList.vue?vue&type=script&lang=js"
export * from "./EmptyList.vue?vue&type=script&lang=js"
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=f8d20204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d20204",
  null
  
)

export default component.exports